import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/courseCard/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/courseCard/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/courseCard/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/courseCard/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/courseCard/delete',
        method: 'post',
        data
    })
}

